import { Box, useTheme } from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { tokens } from "../theme";
import { commonDataGridStyles } from "../styles/DataGridStyles";

// MUI DataGridPro styled to match the Tessell portal table
// (container: #fff / #E5E7EB border / 8px radius; header: #F9FAFB;
//  th: 11px 600 uppercase; rows: 48px, #F3F4F6 divider; td: 13px #374151).
const containerStyles = (colors) => ({
  ...commonDataGridStyles(colors),
  width: "100%",
  background: colors.primary[700],
  border: `1px solid ${colors.grey[800]}`,
  borderRadius: "8px",
  overflow: "hidden",
  "& .MuiDataGrid-columnHeaderTitle": {
    fontWeight: 600,
    letterSpacing: "0.07em",
  },
  "& .MuiDataGrid-cellContent": {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
});

const DataTable = ({
  columns = [],
  rows = [],
  getRowId,
  loading,
  height = "70vh",
  sx,
  ...rest
}) => {
  const theme = useTheme();
  const colors = tokens(theme.paletteId);

  return (
    <Box sx={{ ...containerStyles(colors), height, ...sx }}>
      <DataGridPro
        disableRowSelectionOnClick
        columnHeaderHeight={40}
        rowHeight={48}
        loading={loading}
        rows={rows}
        columns={columns}
        getRowId={getRowId || ((row) => row?.id)}
        sx={{
          "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within, & .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within":
            { outline: "none" },
        }}
        {...rest}
      />
    </Box>
  );
};

export default DataTable;
